import CustomLayout from '@/common/Layout';
import React, { useState, useEffect } from 'react';
import CloningPage from './components/Cloning';
import InititateEnvelopePage2 from './components/InitiateEnvelopePage2';
import { useDispatch, useSelector } from 'react-redux';
import { history } from 'app/history';
import { useParams } from 'react-router-dom';
import { Form } from 'antd';
// import dayjs from 'dayjs';
import moment from 'moment';
import { getclonebyid } from './redux/slice';
import {
  getPlants,
  getfunctions,
  getcategory,
  getactivity,
  getIONum,
  getCOSTNum,
  getsubCategory,
  get_bcj
} from '../dashboard/redux/slice';

import {
  createEnvelop,
  createStandardEnvelop
} from '../initiate-envelope/redux/slice';

function ActionsRequired() {
  const dispatch = useDispatch();
  const params = useParams();
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [itemList, setItemList] = useState([{ id: 1, value: '', envtype: '' }]);
  const [mergedPdfBlob, setMergedPdfBlob] = useState(null);
  const [initiate, setInitiate] = useState(false);
  const [formValues, setformValues] = useState({});
  const [signOrder, setSignOrder] = useState(true);
  const [fileList, setFileList] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [search, setSearch] = useState('');
  const [departmentSearch, setDepartmentSearch] = useState('');
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [ioBalanceAmount, setIoBalanceAmount] = useState(0);
  // const [ionum, setIonum] = useState('');
  // const [ioData, setIoData] = useState({});
  // const [costnum, setCostnum] = useState('');
  // const [costData, setCostData] = useState({});
  // const [nfaAmount, setNfaAmount] = useState(0);
  // const [isValidNfa, setIsValidNfa] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [departmentt, setDepartmentt] = useState('');
  const [plant, setPlant] = useState('');
  const [activityID, setActivityId] = useState('');
  const [businesscasejustification, setbusinesscasejustification] =
    useState('');

  const env_mode = 'edit';
  const { cloning_data } = useSelector((state) => state.cloningdataList);

  useEffect(() => {
    if (cloning_data && Object.keys(cloning_data).length > 0) {
      localStorage.setItem('getCostNum', JSON.stringify(cloning_data));
    }
  }, [cloning_data]);
  const {
    get_plants,
    get_functions,
    get_category,
    get_subcategorylist,
    get_activity,
    get_ioNum,
    get_costNum,
    get_businesscasejustification
  } = useSelector((state) => state.dashboard);

  const plants = get_plants;
  const functions = get_functions;
  const get_COSTNumber = get_costNum;
  const get_IONumbers = get_ioNum;
  const category = get_category;
  const subcategory = get_subcategorylist;
  const activity = get_activity;
  const bcj = get_businesscasejustification;

  const env_type = localStorage.getItem('env_type');
  // console.log('env_type', cloning_data?.bcj);

  // console.log('get_subcategorylist', get_subcategorylist);

  useEffect(() => {
    handleGetCloneData();
  }, [params]);

  useEffect(() => {
    // handlegetLocations();
    handleGetCloneData();
    handlegetPlants();
    handlegetfunctions();
    handlegetcategory();
    handlegetactivity();
    handlegetIONum();
    handlegetCOSTNum();
    handlegetsubcategory();
    handlegetBCJ();

    localStorage.removeItem('apiCallValues');
  }, []);

  const apiCallVal = JSON.parse(localStorage.getItem('apiCallValues')) || {};
  console.log('apiCallVal', apiCallVal);
  const data = apiCallVal?.env_type === cloning_data?.type;
  // console.log('apiCallVal123456', apiCallVal);

  useEffect(() => {
    setIsDisabled(
      cloning_data?.type === 'standard' || cloning_data?.type === 'custom'
    );
  }, [cloning_data]);

  useEffect(() => {
    const selectedCategoryId =
      apiCallVal?.category_id || cloning_data?.category_id;
    // console.log('data', apiCallVal?.category_id);
    if (selectedCategory !== null) {
      // console.log('Selected Category in Parent:', selectedCategory);
      const payload = selectedCategoryId;
      console.log('selected_payload', payload);
      // API call logic here based on selectedCategory
      dispatch(getsubCategory(payload));
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (cloning_data) {
      // // Fetch subcategories for the selected category
      // setSelectedCategory(cloning_data?.category_id);
      const selectedCategoryId = selectedCategory || cloning_data?.category_id;
      // apiCallVal?.category_id || cloning_data?.category_id;

      const selectedCategoryObj = category.find(
        (cat) => cat.id === selectedCategoryId
      );
      // console.log('setSelectedCategory123', selectedCategoryObj.category_name);
      form.setFieldsValue({ sub_category_id: undefined });
      // Get the category name like 'Capex' or 'Opex'
      const selectedCategoryName = selectedCategoryObj
        ? selectedCategoryObj.category_name
        : '';
      // console.log('setSelectedCategory123', selectedCategoryName);
      setSelectedCategory(selectedCategoryName);
      // console.log('setSelectedCategory123', selectedCategoryName);
      if (handleCategoryChangeFromChild) {
        // handleCategoryChangeFromChild(cloning_data?.category_id);
        // console.log('456selectedCategoryId', selectedCategoryId);
        handleCategoryChangeFromChild(selectedCategoryId);
      }
      setFieldsDisabled(true);
      const initialBalance =
        cloning_data?.balance_amount || ioBalanceAmount || 0;

      // Set date states
      // const startDate = data
      //   ? apiCallVal?.project_start_date || ''
      //   : cloning_data?.project_start_date || '';
      // const endDate = data
      //   ? apiCallVal?.project_end_date || ''
      //   : cloning_data?.project_end_date || '';

      // setProjectStartDate(startDate);
      // setProjectEndDate(endDate);

      form.setFieldsValue({
        // plant_id: cloning_data?.plant_id || '',
        plant_id: data
          ? apiCallVal?.plant_id || ''
          : cloning_data?.plant_id || '',
        // department_id: cloning_data?.department_id || '',
        department_id: data
          ? apiCallVal?.department_id || ''
          : cloning_data?.department_id || '',
        // nfa_amount: cloning_data?.nfa_amount || '',
        nfa_amount: data
          ? apiCallVal?.nfa_amount || ''
          : cloning_data?.nfa_amount || '',
        balance_amount: initialBalance || '',
        category_id: selectedCategory,
        // title: cloning_data?.title || '',
        title: data ? apiCallVal?.title || '' : cloning_data?.title || '',
        // description: cloning_data?.title || '',
        description: data
          ? apiCallVal?.description || ''
          : cloning_data?.description || '',
        // emailmessage: cloning_data?.message || '',
        emailmessage: data
          ? apiCallVal?.emailmessage || ''
          : cloning_data?.message || '',

        // sub_category_id: cloning_data?.sub_category_id || '',
        sub_category_id: data
          ? apiCallVal?.sub_category_id || ''
          : cloning_data?.sub_category_id || '',
        // io_no_id: cloning_data?.io_no?.id || '',
        io_no_id: data
          ? apiCallVal?.io_no_id || ''
          : cloning_data?.io_no?.id || '',
        // io_amount: cloning_data?.io_no?.amount || '',
        io_amount: data
          ? apiCallVal?.io_amount || ''
          : cloning_data?.io_no?.amount || '',
        // io_balance_amount: cloning_data?.io_no?.balance_amount || '',
        io_balance_amount: data
          ? apiCallVal?.io_balance_amount || ''
          : cloning_data?.io_no?.balance_amount || '',
        // activity_id: cloning_data?.activity_id || ''
        // activity_id: data
        //   ? apiCallVal?.activity || ''
        //   : cloning_data?.activity_id || '',
        activity: data
          ? apiCallVal?.activity || ''
          : cloning_data?.activity || '',
        business_case_justification: data
          ? apiCallVal?.business_case || ''
          : cloning_data?.business_case || '',
        payback_period: data
          ? apiCallVal?.payback_period || ''
          : cloning_data?.payback_period || '',
        cost_centr_id: data
          ? apiCallVal?.cost_centr_id || ''
          : cloning_data?.cost_centr_id || '',
        remarks: data ? apiCallVal?.remarks || '' : cloning_data?.remarks || '',
        // project_start_date: data
        //   ? apiCallVal?.project_start_date || ''
        //   : cloning_data?.project_start_date || '',
        project_start_date: data
          ? apiCallVal?.project_start_date
            ? moment(apiCallVal.project_start_date)
            : null
          : cloning_data?.project_start_date
          ? moment(cloning_data.project_start_date)
          : null,
        project_end_date: data
          ? apiCallVal?.project_end_date
            ? moment(apiCallVal.project_end_date)
            : null
          : cloning_data?.project_end_date
          ? moment(cloning_data.project_end_date)
          : null,

        project_objective: data
          ? apiCallVal?.project_objective || ''
          : cloning_data?.project_objective || '',
        email: data ? apiCallVal?.email || '' : cloning_data?.email || '',
        name: data ? apiCallVal?.name || '' : cloning_data?.name || ''
      });
    }
  }, [cloning_data, ioBalanceAmount, form]);

  // console.log('cloning_data?.business_case', cloning_data?.business_case);

  useEffect(() => {
    if (
      env_type === 'custom' ||
      env_type === 'standard' ||
      // env_type !== 'ad_hoc'
      env_mode === 'edit'
    ) {
      if (cloning_data?.envelope_approvers) {
        let selectedOption = [];
        let itemList = [];
        cloning_data?.envelope_approvers.forEach((item) => {
          // console.log('item_items', item?.envelope_approver);
          selectedOption = [
            ...selectedOption,
            {
              name: item?.envelope_approver?.display_name,
              email: item?.envelope_approver?.email,
              job_title: item?.envelope_approver?.job_title,
              approver_id: item?.approver_id
            }
          ];
          itemList = [
            ...itemList,
            {
              id: item.id,
              value: item.email,
              envtype: item.id,
              approver_id: item?.id
            }
          ];
        });
        setSelectedOption(selectedOption);
        setApprovers(selectedOption);
        setItemList(itemList);
      }
    }
  }, [cloning_data]);

  const handleGetCloneData = () => {
    let payload = {
      id: params.id
    };
    dispatch(getclonebyid(payload));
  };

  const handlegetPlants = () => {
    dispatch(getPlants());
  };

  const handlegetfunctions = () => {
    dispatch(getfunctions());
  };

  const handlegetcategory = () => {
    dispatch(getcategory());
  };

  const handlegetactivity = () => {
    dispatch(getactivity());
  };

  const handlegetIONum = () => {
    dispatch(getIONum());
  };

  const costnumDetails = JSON.parse(localStorage.getItem('getCostNum')) || {};
  console.log('costnumDetails_parent', costnumDetails);
  const handlegetCOSTNum = () => {
    // console.log('setPlant', cloning_data?.plant_id);
    // console.log('setDepartment', cloning_data?.department_id);
    let payload = {
      plant_id: costnumDetails?.plant_id,
      department_id: costnumDetails?.department_id,
      user: 'user'
    };
    dispatch(getCOSTNum(payload));
    // dispatch(getCOSTNum());
  };

  const handlegetsubcategory = () => {
    dispatch(getsubCategory());
  };

  const handlePlant = (value) => {
    setPlant(value);
  };
  const handleDepartmentt = (value) => {
    setDepartmentt(value);
  };
  const handleBCJ = (value) => {
    setbusinesscasejustification(value);
  };

  const handleActivity = (value) => {
    setActivityId(value);
  };

  const handleSearch = (e) => {
    setSearch(e);
  };

  const handleDepartmentSearch = (e) => {
    setDepartmentSearch(e);
  };

  const handlegetBCJ = () => {
    dispatch(get_bcj());
  };

  useEffect(() => {
    console.log('search', search);
    const payload = { search: search };
    dispatch(getPlants(payload));
  }, [search]);

  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    // setSelectedCategory(selectedValue); // Update local state
    // console.log('selected_123Value', selectedValue);

    // Find the category object from the category array using the selected id
    const selectedCategoryObj = category.find(
      (cat) => cat.id === selectedValue
    );
    form.setFieldsValue({ sub_category_id: undefined });
    // Get the category name like 'Capex' or 'Opex'
    const selectedCategoryName = selectedCategoryObj
      ? selectedCategoryObj.category_name
      : '';

    setSelectedCategory(selectedCategoryName);
    // console.log('123selected123Value', selectedCategory);
    if (handleCategoryChangeFromChild) {
      // console.log('123selected123Value', selectedValue);
      handleCategoryChangeFromChild(selectedValue);
    }
  };

  const handleCategoryChangeFromChild = (value) => {
    // console.log('handleCategoryChangeFromChild', value);
    setSelectedCategory(value);
  };

  const handleFormSubmit = () => {
    setInitiate(true);

    // const categoryId = form.getFieldValue('category_id');
    // const nfaAmount = form.getFieldValue('nfa_amount');

    // // ✅ Validation: For Category 1, NFA Amount must be > 15,00,000
    // if (Number(categoryId) === 1 && Number(nfaAmount) <= 1500000) {
    //   setInitiate(false);
    //   return message.error(
    //     'NFA Amount must be greater than ₹15,00,000 for this category'
    //   );
    // }
    let updatd = [];
    // console.log('selectedOption123456', selectedOption);
    selectedOption.map((item, index) => {
      var obj = {};
      obj['name'] = item.display_name;
      obj['email'] = item.email;
      obj['approver_id'] = item.approver_id;
      signOrder ? (obj['sequence'] = index + 0) : '';
      obj['sign_in'] = index === 0 ? true : false;
      updatd.push(obj);
    });
    // console.log('fileList in Parent', mergedPdfBlob);
    let formData = new FormData();

    fileList.forEach((file) => {
      formData.append(`documents`, file);
    });
    // console.log('type', env_type);

    const apiCallValues = localStorage.getItem('apiCallValues');
    formData.append('type', env_type ? env_type : 'ad-hoc');
    // console.log('formValues?.message', formValues?.emailmessage);
    // console.log('setformValues', formValues);
    if (env_type !== 'standard' && env_type !== 'custom') {
      formData.append('title', formValues?.title);
      formData.append('plant_id', formValues?.plant_id);
      formData.append('department_id', formValues?.department_id);
      formData.append('approvers', JSON.stringify(updatd));
      formData.append('description', formValues?.description);
      formData.append('message', formValues?.emailmessage);
      formData.append('nfa_amount', formValues?.nfa_amount);
      formData.append('balance_amount', formValues?.balance_amount);
      formData.append('signing_order', signOrder);
    } else {
      formData.append('approvers', JSON.stringify(updatd));
      formData.append('description', formValues?.description);
      formData.append('message', formValues?.emailmessage);
      // formData.append('flow_id', localStorage.getItem('flow_id'));
      formData.append('signing_order', signOrder);
      formData.append('title', localStorage.getItem('envelope_name'));
      if (apiCallValues) {
        const parsedValues = JSON.parse(apiCallValues);
        formData.append('category_id', parsedValues.category_id);
        formData.append('sub_category_id', parsedValues.sub_category_id);
        formData.append('plant_id', parsedValues.plant_id);
        formData.append('department_id', parsedValues.department_id);
        formData.append('nfa_amount', parsedValues.nfa_amount);
        formData.append('balance_amount', parsedValues.balance_amount);
        // formData.append('io_no_id', parsedValues.io_no_id);
        formData.append(
          'flow_id',
          parsedValues.flow_id ? parsedValues.flow_id : ''
        );
        formData.append(
          'io_no_id',
          parsedValues.io_no_id ? parsedValues.io_no_id : ''
        );
        formData.append(
          'io_amount',
          parsedValues.io_amount ? parsedValues.io_amount : ''
        );
        // formData.append('activity_id', parsedValues.activity);
        formData.append('activity', parsedValues.activity);
        formData.append(
          'business_case',
          parsedValues.business_case_justification
        );
        formData.append('payback_period', parsedValues.payback_period);
        formData.append('cost_centr_id', parsedValues.cost_centr_id);
        formData.append('remarks', parsedValues.remarks);
        formData.append(
          'project_start_date',
          parsedValues.project_start_date || ''
        );
        formData.append(
          'project_end_date',
          parsedValues.project_end_date || ''
        );
        formData.append('project_objective', parsedValues.project_objective);
        formData.append('email', parsedValues.email ? parsedValues.email : '');
        formData.append('name', parsedValues.name ? parsedValues.name : '');
        // formData.append(
        //   'cost_center_amount',
        //   parsedValues.cost_center_amount ? parsedValues.cost_center_amount : ''
        // );
        // formData.append(
        //   'cost_center_balance_amount',
        //   parsedValues.cost_center_balance_amount
        // );
      }
    }

    const dispatchAction =
      env_type === 'standard' || env_type === 'custom'
        ? createStandardEnvelop
        : createEnvelop;

    // dispatch(createEnvelop(formData)).then((response) => {
    dispatch(dispatchAction(formData)).then((response) => {
      if (response.payload.success) {
        setInitiate(false);
        setSignOrder(false);
        history.push('/dashboard');
      } else {
        setInitiate(false);
      }
    });
  };

  return (
    <CustomLayout sider={false} tracker={false} header={false}>
      {current == 0 ? (
        <CloningPage
          cloning_data={cloning_data}
          form={form}
          current={current}
          setCurrent={setCurrent}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          mergedPdfBlob={mergedPdfBlob}
          setMergedPdfBlob={setMergedPdfBlob}
          initiate={initiate}
          setInitiate={setInitiate}
          formValues={formValues}
          setformValues={setformValues}
          setSignOrder={setSignOrder}
          signOrder={signOrder}
          setFileList={setFileList}
          fileList={fileList}
          itemList={itemList}
          setItemList={setItemList}
          approvers={approvers}
          setApprovers={setApprovers}
          env_mode={env_mode}
          selectedCategory={selectedCategory}
          // setSelectedCategory={setSelectedCategory}
          plants={plants}
          functions={functions}
          get_COSTNumber={get_COSTNumber}
          get_IONumbers={get_IONumbers}
          category={category}
          subcategory={subcategory}
          activity={activity}
          search={search}
          setSearch={setSearch}
          departmentSearch={departmentSearch}
          setDepartmentSearch={setDepartmentSearch}
          fieldsDisabled={fieldsDisabled}
          setFieldsDisabled={setFieldsDisabled}
          ioBalanceAmount={ioBalanceAmount}
          setIoBalanceAmount={setIoBalanceAmount}
          handleCategoryChange={handleCategoryChange}
          // handleIONumChange={handleIONumChange}
          // handleCostNumChange={handleCostNumChange}
          // isValidNfa={isValidNfa}
          // handleNfaAmountChange={handleNfaAmountChange}
          isDisabled={isDisabled}
          handleDepartmentSearch={handleDepartmentSearch}
          handleSearch={handleSearch}
          handlePlant={handlePlant}
          handleDepartmentt={handleDepartmentt}
          departmentt={departmentt}
          plant={plant}
          handleBCJ={handleBCJ}
          business_case_justification={businesscasejustification}
          bcj={bcj}
          handleActivity={handleActivity}
          activityID={activityID}
        />
      ) : (
        <InititateEnvelopePage2
          current={current}
          setCurrent={setCurrent}
          functions={get_functions}
          plants={get_plants}
          category={get_category}
          activity={get_activity}
          subcategory={get_subcategorylist}
          get_IONumbers={get_ioNum}
          get_COSTNumber={get_costNum}
          selectedOption={selectedOption}
          // setSelectedOption={setSelectedOption}
          mergedPdfBlob={mergedPdfBlob}
          setMergedPdfBlob={setMergedPdfBlob}
          handleFormSubmit={handleFormSubmit}
          initiate={initiate}
          setInitiate={setInitiate}
          formValues={formValues}
          setformValues={setformValues}
          // env_type={env_type}
          setSignOrder={setSignOrder}
          signOrder={signOrder}
          bcj={bcj}
          handleBCJ={handleBCJ}
          business_case_justification={businesscasejustification}
          handleActivity={handleActivity}
          activityID={activityID}
          // handleCategoryChangeFromChild={handleCategoryChangeFromChild}
        />
      )}
      {/* <div>testing site for checking</div> */}
    </CustomLayout>
  );
}

export default ActionsRequired;
